// extracted by mini-css-extract-plugin
export default {"welcome":"welcome__VYmS_ojC","suggestions":"suggestions__dNqT72vD"};